import dayjs from "dayjs";
import React, { useMemo, useState } from "react";
import { useTermsList } from "../../api/inquiries/terms-condition/use-terms-condition";
import TitlePage from "../../components/section/TitlePage/Titlepage";
import Loading from "../../components/ui/Loading/Loading";
import Tabs, { Tablist } from "../../components/ui/Tabs/Tabs";
import TermsConditions from "./Components/TermsConditions";

const tabs = [
  {
    title: "서비스 이용약관",
    id: 1,
  },
  {
    title: "전자지급 결제대행 서비스 이용약관",
    id: 2,
  },
  {
    title: "개인정보 이용 및 제3자 제공 동의서",
    id: 3,
  },
  {
    title: "환불 규정 안내",
    id: 4,
  },
];

const TermsConditionsPage = () => {
  const { data } = useTermsList();
  const [currentTab, setCurrentTab] = useState(1);
  const [editMode, setEditMode] = useState(false);
  const onChangeTab = (id) => {
    setCurrentTab(id);
    setEditMode(false);
  };

  const handleEdit = () => {
    setEditMode(true);
  };

  const onCancelEdit = () => {
    setEditMode(false);
  };

  const terms = useMemo(
    () => ({
      termsOfService: data?.items?.find((res) => res?.type === 0) ?? {},
      electronicTerms: data?.items?.find((res) => res?.type === 1) ?? {},
      personalTerms: data?.items?.find((res) => res?.type === 2) ?? {},
      refundTerms: data?.items?.find((res) => res?.type === 3) ?? {},
    }),
    [data]
  );

  const onSubmit = () => {
    setCurrentTab(0);
    setTimeout(() => {
      setCurrentTab(currentTab);
    }, 500);
    setEditMode(false);
  };

  return (
    <div>
      <TitlePage title="정책&약관 관리" />
      <Tabs
        tabWidth="w-52"
        onChangeTab={onChangeTab}
        currentTab={currentTab}
        tabs={tabs}
      >
        <Tablist currentTab={currentTab} index={1}>
          <TermsConditions
            html={terms.termsOfService?.contents}
            editMode={editMode}
            onEdit={handleEdit}
            onCancelEdit={onCancelEdit}
            onSubmit={onSubmit}
            updatedAt={terms.termsOfService?.updatedAt}
            type={0}
            id={terms.termsOfService?.id}
          />
        </Tablist>
        <Tablist currentTab={currentTab} index={2}>
          <TermsConditions
            html={terms.electronicTerms?.contents}
            editMode={editMode}
            onEdit={handleEdit}
            onCancelEdit={onCancelEdit}
            onSubmit={onSubmit}
            updatedAt={terms.electronicTerms?.updatedAt}
            type={1}
            id={terms.electronicTerms?.id}
          />
        </Tablist>
        <Tablist currentTab={currentTab} index={3}>
          <TermsConditions
            html={terms.personalTerms?.contents}
            editMode={editMode}
            onEdit={handleEdit}
            onCancelEdit={onCancelEdit}
            onSubmit={onSubmit}
            updatedAt={terms.personalTerms?.updatedAt}
            type={2}
            id={terms.personalTerms?.id}
          />
        </Tablist>
        <Tablist currentTab={currentTab} index={4}>
          <TermsConditions
            html={terms.refundTerms?.contents}
            editMode={editMode}
            onEdit={handleEdit}
            onCancelEdit={onCancelEdit}
            onSubmit={onSubmit}
            updatedAt={terms.refundTerms?.updatedAt}
            type={3}
            id={terms.refundTerms?.id}
          />
        </Tablist>
      </Tabs>
      {currentTab === 0 && (
        <div className="w-[-webkit-fill-available] h-full fixed m-auto bg-white z-[99]">
          <Loading />
        </div>
      )}
    </div>
  );
};

export default TermsConditionsPage;
